
export class PlanGoodsEcology2Model {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 環境区分
  public ecologyDiv: string = <string>'';

  // 環境区分選択
  public ecologyDivSelect: string = <string>'';
}
